import TenantResourceModel from '../../generated/types/model/resource/TenantResourceModel';

export default class TenantResourceViewModel extends TenantResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
